import React from 'react';
import { states } from '@/constants/lifecycle';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import ArchiveActionMenu from '@/components/ribbon-actions/ArchiveActionMenu';
import TaskLinkAction from '../tasks/components/TaskLinkAction';
import TaskListAction from '../tasks/components/TaskListAction';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const ReviewActions = ({ category }) => {
  const {
    allowArchive, allowRefresh, allowTasks, isRequester, readStatus, selectedCount, taskLinkEnabled,
  } = Selectors.useReviewActions({ category });
  const refresh = Events.useRefreshRequests(category);
  const showArchive = Events.useShowArchiveRequests(category);

  return (
    <>
      {allowRefresh && (<RefreshActionMenu onClick={() => refresh({ page: 1 })} readStatus={readStatus} />)}
      {allowTasks && (<TaskListAction />)}
      {taskLinkEnabled && (<TaskLinkAction />)}
      {allowArchive && (
        <ArchiveActionMenu
          onClick={showArchive}
          disabled={readStatus === states.PENDING || selectedCount === 0 || isRequester}
          isArchival
        />
      )}
    </>
  );
};

export default ReviewActions;
